import { Injectable } from '@angular/core';
import { CommonapiService } from '../../Shared/Service/Commonapi.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CustomerDetailService {

constructor(public api: CommonapiService, public httpClient: HttpClient) { }

async getcustomerdetail(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetCustomerDetail`,obj,isformupload);    
}
async GetLocation() {
  return await this.api.getLocation();    
}



async saveContactPopup(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/AddContactPopup`,obj,isformupload);    
}

async UpdateAttributes(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/UpdateAttributes`,obj,isformupload);    
}

async UpdateSchoolAttributes(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/UpdateSchoolAttributes`,obj,isformupload);    
}

async AddMonthDropdownList(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetSalesHistoryAddDropdownListValues`,obj,isformupload);    
}
async AddSalesHistoryPopup(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/InsertSalesHistoryPopup`,obj,isformupload);    
}

async EditSalesHistoryPopup(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/UpdateSalesHistoryPopup`,obj,isformupload);    
}

async GetSalesHistorybyFilter(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetSalesHistorybyFilter`,obj,isformupload);    
}
async GetNearByBusiness(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetNearByBusiness`,obj,isformupload);    
}

async GetSchoolDropdownListValues(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetSchoolDropdownListValues`,obj,isformupload);    
}
async getOrderMappedDetails(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetOrderMappedDetails`,obj,isformupload);    
}

async getOrderReceivedDetails(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetOrderReceivedDetails`,obj,isformupload);    
}

async getOrderReceivedPopupDetails(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetOrderReceivedPopupDetails`,obj,isformupload);    
}

async getAddDistributorPopupDetails(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetAddDistributorPopupDetails`,obj,isformupload);    
}

async addDistributorPopupDetails(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/AddDistributorPopupDetails`,obj,isformupload);    
}

async deleteMappedDistributor(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/DeleteMappedDistributor`,obj,isformupload);    
}

async addDigiPin(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/AddDigiPin`,obj,isformupload);    
}

async GetDistributorSearchDetailsCustomerMap(obj: any, isformupload: boolean) {
    return this.api.apiPost(false, `SalesLogin/GetDistributorSearchDetailsCustomerMap`, obj, isformupload);
  }
  
  async GetCDGetDistributor(obj: any, isformupload: boolean) {
    return this.api.apiPost(false, `SalesLogin/CDGetDistributor`, obj, isformupload);
  }

  async CDSaveDistributor(obj: any, isformupload: boolean) {
    return this.api.apiPost(false, `SalesLogin/CDSaveDistributor`, obj, isformupload);
  }

  async GetSalesForecastList(obj:any,isformupload:boolean) {
    return this.api.apiPost(false, `SalesLogin/GetSalesForecastList`,obj,isformupload);    
  }
  async GetSalesForecastPopupList(obj:any,isformupload:boolean) {
    return this.api.apiPost(false, `SalesLogin/GetSalesForecastPopupList`,obj,isformupload);    
  }
  async UpdateSalesForecastPopup(obj:any,isformupload:boolean) {
    return this.api.apiPost(false, `SalesLogin/UpdateSalesForecastPopup`,obj,isformupload);    
  }
  async getInventoryTabDetails(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetInventoryDetails`,obj,isformupload);    
}
async InventoryImageUpload(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/InventoryImageUpload`,obj,true);    
}
async DeleteInventoryUploadImage(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/DeleteInventoryUploadImage`,obj,true);    
}

}
